import '@angular/localize/init';
export * from './lib/feature-tax-bezwaar-list.module';

export * from './lib/tax-bezwaar-list/feature-tax-bezwaar-list.component';
